import background from '../../../../../assets/Images/BackgroundHC.jpg'
import { HeroSection } from '../../../../shared/styles/HelpCenterStyles'

const Hero = () => {
  return (
    <HeroSection
      display="flex"
      sx={{ backgroundImage: `url(${background})` }}
      height={445}
      width="100%"
      alignItems="center"
      justifyContent="center"
    />
  )
}

export default Hero
